// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
footer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: #ededee;
  width: 100%;
  height: 100%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  cursor: default;
}
footer span {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: auto;
  margin-left: 10px;
  margin-right: 10px;
  white-space: nowrap;
  line-height: 24px;
  position: relative;
  text-align: center;
}
footer span:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -10px; /* Ajusta según sea necesario */
  top: 0;
  bottom: 0;
  width: 2px; /* Ancho del separador */
  background-color: #dbdcdd;
}
footer .cvx-footer-environment {
  display: inline;
  padding: 7px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
  background-color: #ba3093;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
